import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";
import { APP_URL } from "@/components/SiteNav";

const STEPS = [
  "Richiedi l'accesso con i dati dell'azienda",
  "Esplora l'Ambiente Demo con profili simulati",
  "Attiva il pacchetto (Horizon, Vision, Omega self-service; Insights su richiesta) e, se vuoi, aderisci alla Formazione Scuola-Lavoro per lo sconto.",
];

export const ComeIniziare = () => (
  <section className="relative px-6 py-20 lg:py-32" data-testid="come-iniziare-section">
    <div className="max-w-6xl mx-auto">
      <Reveal className="mb-14 lg:mb-20">
        <Eyebrow className="mb-6">Come iniziare</Eyebrow>
        <h2 className="font-extrabold tracking-[-0.04em] leading-[1] text-4xl sm:text-5xl lg:text-6xl">Tre passi, zero attese.</h2>
      </Reveal>
      <ol className="steps relative grid gap-10 lg:grid-cols-3 lg:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s} delay={i * 140} className="relative">
            <li className="relative flex lg:flex-col gap-5" data-testid={`step-${i + 1}`}>
              <span className="step-num relative z-10 h-14 w-14 shrink-0 rounded-full border flex items-center justify-center font-mono text-lg font-semibold text-cyan">
                {i + 1}
              </span>
              <p className="pt-3 lg:pt-0 text-base sm:text-lg leading-relaxed text-white/90">{s}</p>
            </li>
          </Reveal>
        ))}
      </ol>
      <Reveal className="mt-14 lg:mt-16">
        <a href={APP_URL} target="_blank" rel="noopener noreferrer" className="cta cta-mega glass inline-flex min-h-[52px] items-center justify-center gap-2.5 rounded-full border px-8 py-4 text-sm sm:text-base font-bold text-white" data-testid="come-iniziare-cta">
          Richiedi l'accesso <ArrowUpRight className="h-4 w-4 text-cyan" />
        </a>
      </Reveal>
    </div>
  </section>
);
